const routes = (module.exports = require('next-routes')());

routes
  .add('', '/save', 'index')
  .add('mutualfund', '/mutual-funds', 'mfHome')
  .add('mfHome', '/mf', 'mfHome')
  .add('amcs', '/mutual-funds/catalogue', 'amcs')
  .add('nfos', '/mf/nfo', 'nfos')
  .add('mutualfund-nfos', '/mutual-funds/nfo', 'nfos')
  .add('nfoDetails', '/nfoDetails', 'nfoDetails')
  .add('login', '/save/login', 'login')
  .add('google-auth', '/save/google-auth', 'google-auth')
  .add('logout', '/save/logout', 'logout')
  .add('complete-kyc', '/save/complete-kyc', 'complete-kyc')
  .add('payment', '/save/payment')
  .add('paymentSuccess', '/save/orders', 'paymentSuccess')
  .add('plan', '/save/plan/:id', 'plan')
  .add('plan-v2', '/save/plan-v2/:id', 'plan-v2')
  .add('dashboard', '/save/dashboard/:name', 'dashboard')
  .add('dashboardRedirect', '/save/dashboard', 'dashboardRedirect')
  .add('redeemSummary', '/save/redeemSummary/:id')
  .add('mandate', '/save/mandate', 'mandate')
  .add('kyc', '/save/kyc')
  .add('referral', '/save/referral')
  .add('appIssues', '/save/app/downloadissues')
  .add('special-referral', '/save/special-referral', 'special-referral')
  .add('help', '/save/help')
  .add('refer', '/save/refer/:referCode', 'refer')
  .add('personalised-plan', '/save/personalised-plan')
  .add('personalized-plan', '/save/personalized-plan/:f2s_version?/:segment?')
  .add('f2s', '/save/f2s/:f2s_version?/:segment?')
  .add('filing-to-save', '/save/filing-to-save')
  .add('profile', '/save/profile')
  .add('search', '/save/search')
  .add('amc-mutual-funds', '/mutual-funds/:slug', 'amc')
  .add('amc', '/mf/:slug', 'amc')
  .add(
    'single-fund-mutual-funds',
    '/mutual-funds/:amcSlug/:fundSlug/:fundIsin',
    'single-fund'
  )
  .add('single-fund', '/mf/:amcSlug/:fundSlug/:fundIsin', 'single-fund')
  .add(
    'single-fund-slug-mutual-funds',
    '/mutual-funds/:amcSlug/:fundSlug',
    'single-fund'
  )
  .add('single-fund-nfo', '/mf/nfo/:amcSlug/:fundSlug/:fundIsin', 'single-fund')
  .add('single-fund-slug', '/mf/:amcSlug/:fundSlug', 'single-fund')
  .add('single-fund-slug-nfo', '/mf/nfo/:amcSlug/:fundSlug/', 'single-fund')

  .add(
    'single-fund-nfo-mutual-funds',
    '/mutual-funds/nfo/:amcSlug/:fundSlug/:fundIsin',
    'single-fund'
  )
  .add(
    'single-fund-slug-nfo-mutual-funds',
    '/mutual-funds/nfo/:amcSlug/:fundSlug/',
    'single-fund'
  )

  .add('compare-funds', '/save/compare-funds', 'compare-funds')
  .add('elss-calculator', '/save/elss-calculator', 'elss-calculator')
  .add('sip-calculator', '/save/sip-calculator', 'sip-calculator')
  .add('mandate-status', '/save/mandate-status', 'mandate-status')
  .add('calculator80C', '/save/calculator-80c')
  .add('grow-wealth', '/save/grow-wealth')
  .add(
    'whatsapp-confirmation',
    '/save/whatsapp-confirmation',
    'whatsapp-confirmation'
  )
  .add('save-taxes', '/save/save-taxes', 'save-taxes')
  .add('rent-page', '/save/rent')
  .add('invest', '/save/invest/:investIn/:investInID', 'invest')
  .add('complete-payment', '/save/complete-payment')
  .add('postFiling', '/save/post-filing/rewards/advisory')
  .add('status', '/save/status/:name?')
  .add('indexMobile', '/save/indexMobile')
  .add('yesBankCrisisFaq', '/save/yesbank-faq')
  .add('redirect', '/save/(.*)')
  .add('currency', '/currency/:slug', 'currency')
  .add('logoutcurrency', '/logoutcurrency', 'logoutcurrency');



// WEBPACK FOOTER //
// ./configs/routes.js